import * as Common from '@/agiles/common';


export class Permission extends Common.ObjectBase{
    constructor(){
        super('Permission');        
    }    
        public id: number =0;
        public name: string;
        public mode: Common.permissionFlags = Common.permissionFlags.Include;
        public groupId: string;
        public userId: string;
        public items: string[] =new Array();
}

export class PermissionQuery extends Common.LoadQuery {
  constructor() {
    super('PermissionQuery', Permission);
    this.sort = 'userId';
  }
  public name: string;
  public userId: string;          
}

export class UserPermissionQuery extends Common.Query {
    constructor(){
        super('UserPermissionQuery', new Common.ModelBinder(Common.Permission,true))
    }
}